// @flow

import style from "./style.module.scss";

import React, { type Node, type Element, useState } from "react";
import { Col, Row } from "reactstrap";
import { Section } from "@containers";
import { ShowHideMap, SearchContainer } from "@components";
import { PushEvent } from "../../components/Tracker/Tracker";
import { type PageContentProps } from "../PageContent";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import type { MapViewEvent } from "../../models/events";
import { t } from "ttag";

type Props = {
    headerProps: $Diff<PageContentProps, { children: * }>,
    Filter: Element<*>,
    Map: Element<*>,
    Results: React$Element<*>,
    Breadcrumb?: Node,
    showMapByDefault?: boolean,
    pageTitle?: string,
    isLoading: boolean,
};

const FilterType = {
    agency: "agencyFilter",
    property: "propertyFilter",
};

const CollectionSearch = ({
    Filter,
    Map,
    Results,
    showMapByDefault,
    pageTitle,
    isLoading,
}: Props) => {
    const sendToGTM = useGTMDispatch();

    const [mapVisible, setMapVisible] = useState(!!showMapByDefault);

    const containsAgencyFilter =
        Filter?.props?.filterType === FilterType.agency;
    const toggleMapView = (visible: boolean) => {
        const gtmEvent: MapViewEvent = {
            active: visible,
            type: "MapViewEvent",
        };
        PushEvent(gtmEvent, sendToGTM);
        setMapVisible(visible);
    };
    const showHideMap = (
        <div className={style.showHideMap}>
            <ShowHideMap
                mapVisible={mapVisible}
                onShowClick={() => {
                    toggleMapView(true);
                }}
                onHideClick={() => toggleMapView(false)}
                className={style.showHideMap}
            />
        </div>
    );

    const RenderSearchResultsHeader = () => {
        if (containsAgencyFilter) {
            return (
                <>
                    <span
                        className={style.agencyOverviewTitle}
                    >{t`agency-overview.our-agencies`}</span>
                    {showHideMap}
                </>
            );
        } else {
            return showHideMap;
        }
    };

    return (
        <div className={containsAgencyFilter ? style.offsetFilter : ""}>
            <Section theme={containsAgencyFilter ? "themeGold" : ""}>
                <Row>
                    <Col>{Filter}</Col>
                </Row>
            </Section>
            <SearchContainer
                pageTitle={pageTitle}
                mapVisible={mapVisible}
                map={Map}
                results={Results}
                RenderSearchResultsHeader={RenderSearchResultsHeader}
                isLoading={isLoading}
            />
        </div>
    );
};

export default CollectionSearch;
